import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-exponent-website" as const;

export const OpenExponentWebsiteEventDataSchema = z.object({
  structureId: z.string(),
  eventId: z.string(),
});

export type OpenExponentWebsiteEventData = z.infer<
  typeof OpenExponentWebsiteEventDataSchema
>;

export type OpenExponentWebsiteEvent = AppEvent<
  typeof eventName,
  OpenExponentWebsiteEventData
>;

export const isOpenExponentWebsiteEvent = (
  event: AnyAppEvent
): event is OpenExponentWebsiteEvent => event.name === eventName;

export { eventName as openExponentWebsite };
